import type { JSX } from 'preact';

interface InputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: 'text' | 'password' | 'date';
  id?: string;
  className?: string;
  icon?: 'search';
}

const ICONS: Record<string, string> = {
  search: '<circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>',
};

export function Input({
  value,
  onChange,
  placeholder,
  type = 'text',
  id,
  className,
  icon,
}: InputProps) {
  const handleInput = (e: JSX.TargetedEvent<HTMLInputElement>) => {
    onChange(e.currentTarget.value);
  };

  if (icon) {
    return (
      <div class="input-with-icon">
        <svg
          class="input-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          dangerouslySetInnerHTML={{ __html: ICONS[icon] }}
        />
        <input
          type={type}
          value={value}
          onInput={handleInput}
          placeholder={placeholder}
          id={id}
          class={`input-icon-field${className ? ` ${className}` : ''}`}
        />
      </div>
    );
  }

  return (
    <input
      type={type}
      value={value}
      onInput={handleInput}
      placeholder={placeholder}
      id={id}
      class={className}
    />
  );
}
